export default "__VITE_ASSET__BFcmx8zk__"